// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__wpx9-","tab":"ProcedureTabs_tab__2w-c6"};